import { PROCEEDING_TYPES } from './constants'

export const mapComplaintResponseToForm = (currentComplaint, data, { isCopy = false } = {}) => {
    const normalizedWayOfProceeding = (() => {
        const proceeding = Array.isArray(data.complaintWayOfProceeding)
            ? data.complaintWayOfProceeding[0]
            : data.complaintWayOfProceeding

        if (!proceeding) {
            return {
                complaintWayOfProceedingId: null,
                value: null
            }
        }

        return {
            complaintWayOfProceedingId: proceeding.complaintWayOfProceedingId ?? proceeding.id ?? null,
            value: proceeding.value ?? null
        }
    })()

    const complaintOrderComplaintDetails = (data.complaintOrderComplaint || [])
        .map(order => ({
            orderNumber: order?.orderNumber || '',
            productTypeName: order?.productTypeName || order?.productType || null,
        }))
        .filter(item => Boolean(item.orderNumber))

    const complaint = Object.assign({}, currentComplaint, {
        id: isCopy ? null : data.id,
        complaintStatusId: data.complaintStatusId,
        complaintProductionDepartmentId: data.complaintProductionDepartmentId,
        machineId: data.machineId,
        jobNumber: data.jobNumber,
        complaintOrderComplaint: complaintOrderComplaintDetails.map(item => item.orderNumber),
        complaintOrderComplaintDetails,
        discrepancyCatcher: data.discrepancyCatcher,
        discrepancyCatcherId: data.discrepancyCatcherId,
        complaintProductDescription: data.complaintProductDescription,
        complaintAttachment: data.complaintAttachment,
        responsiblePerson: data.responsiblePerson,
        productionSiteGroupId: data.productionSiteGroupId,
        productionProcessId: data.productionProcessId,
        errorCodeGroupId: data.errorCodeGroupId,
        errorCodeId: data.errorCodeId,
        defects: data.defects,
        discrepancyCause: data.discrepancyCause,
        correctiveMeasures: data.correctiveMeasures,
        complaintErrorId: data.complaintErrorId,
        complaintWayOfProceeding: normalizedWayOfProceeding,
        responsiblePersonRead: data.responsiblePersonRead
    })

    const responsibleUsers = Array.isArray(data.responsiblePersonRead)
        ? data.responsiblePersonRead.map(user => ({
            id: user.user.id,
            firstName: user.user.firstName,
            lastName: user.user.lastName,
        }))
        : null

    const discrepancyCatcherUser = data.discrepancyCatcher
        ? {
            id: data.discrepancyCatcher.id,
            firstName: data.discrepancyCatcher.firstName,
            lastName: data.discrepancyCatcher.lastName,
        }
        : null

    return {
        complaint,
        responsibleUsers,
        discrepancyCatcherUser,
    }
}

export const collectComplaintDependencies = (store, moduleName, data = {}) => {
    const tasks = [
        store.dispatch(`${moduleName}/getErrors`),
        store.dispatch(`${moduleName}/getProductionDepartments`),
        store.dispatch(`${moduleName}/getErrorCodeGroups`),
        store.dispatch(`${moduleName}/getProceedingWays`),
        store.dispatch(`${moduleName}/getStatuses`)
    ]

    if (data.jobNumber) {
        tasks.push(store.dispatch(`${moduleName}/getReportItems`, data.jobNumber))
    }

    if (data.complaintProductionDepartmentId) {
        tasks.push(store.dispatch(`${moduleName}/getProductionSiteGroups`, data.complaintProductionDepartmentId))

        const processQuery = data.productionSiteGroupId
            ? { productionSiteGroupId: data.productionSiteGroupId }
            : { complaintProductionDepartmentId: data.complaintProductionDepartmentId }

        tasks.push(store.dispatch(`${moduleName}/getProductionProcesses`, processQuery))
    }

    if (data.productionSiteGroupId) {
        tasks.push(store.dispatch(`${moduleName}/getMachines`, data.productionSiteGroupId))
    }

    return tasks
}

export const buildComplaintPayload = (complaint) => {
    const { complaintOrderComplaintDetails, ...restComplaint } = complaint
    const adjustmentType = PROCEEDING_TYPES.ADJUSTMENT
    const proceeding = complaint.complaintWayOfProceeding || {}
    const hasProceeding = Boolean(proceeding.complaintWayOfProceedingId)
    const requiresAdjustmentValue = proceeding.complaintWayOfProceedingId === adjustmentType
    const proceedingValue = requiresAdjustmentValue && proceeding.value !== null && proceeding.value !== '' && proceeding.value !== undefined
        ? Number(proceeding.value)
        : proceeding.value
    const productTypeNameByOrderNumber = (complaintOrderComplaintDetails || []).reduce((accumulator, item) => {
        if (!item?.orderNumber) {
            return accumulator
        }

        accumulator[item.orderNumber] = item.productTypeName || null

        return accumulator
    }, {})

    return {
        ...restComplaint,
        complaintWayOfProceeding: hasProceeding
            ? [{
                complaintWayOfProceedingId: proceeding.complaintWayOfProceedingId,
                value: proceedingValue,
            }]
            : [],
        complaintAttachmentId: complaint.complaintAttachment.map(attachment => attachment.id),
        complaintOrderComplaint: (complaint.complaintOrderComplaint || []).map(order => {
            const orderNumber = typeof order === 'string'
                ? order
                : (order?.orderNumber || order?.value || '')

            return {
                orderNumber,
                productTypeName: productTypeNameByOrderNumber[orderNumber] || null,
            }
        }),
    }
}
